import Chip, { ChipProps } from "@mui/material/Chip";

import { colors } from "theme";

export const CustomChip = (props: ChipProps) => {
  return (
    <Chip
      {...props}
      sx={{
        textTransform: "capitalize",
        ...(props.color === "error" && {
          backgroundColor: colors.redLightContrast,
          color: colors.redLight
        })
      }}
    />
  );
};
